'use client'
import { forwardRef, StepTitle as ChakraStepTitle } from '@chakra-ui/react'
import { LegacyRef } from 'react'

import { StepTitleProps } from './StepTitle.types'

export default forwardRef(function StepTitle(
  props: StepTitleProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return <ChakraStepTitle {...props} ref={ref} translate="no" />
})
